import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-50 flex items-center justify-between gap-3 bg-yellow-500 px-4 py-2 text-sm font-medium text-black">
      <span className="flex items-center gap-2">
        <WifiOff className="h-4 w-4 shrink-0" />
        Sin conexión — los cambios no se guardarán hasta que vuelvas a conectarte
      </span>
      <button
        onClick={() => window.location.reload()}
        className="shrink-0 rounded bg-black/10 px-3 py-1 text-xs font-semibold hover:bg-black/20 active:bg-black/30"
      >
        Reintentar
      </button>
    </div>
  );
}
